import { useLocation, Link } from 'react-router-dom';
import { getDocumentiSezione } from '../../config/documentiSezioni';

export default function DocumentiSezioneBox() {
  const location = useLocation();
  const documenti = getDocumentiSezione(location.pathname);
  // Nella dashboard il documento si apre con la sidebar (/dashboard/documento/:id), altrove nella versione pubblica
  const base = location.pathname.startsWith('/dashboard') ? '/dashboard/documento' : '/documento';

  if (documenti.length === 0) return null;

  return (
    <div className="mt-8 bg-white rounded-2xl shadow-sm border border-gray-100 p-6 md:p-8">
      <h3 className="font-semibold text-gray-800 mb-4">Documenti utili</h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {documenti.map((doc) => (
          <Link
            key={doc.id}
            to={`${base}/${doc.id}`}
            className="flex items-center gap-3 p-4 bg-gray-50 hover:bg-blue-50 rounded-xl border border-gray-100 hover:border-blue-200 transition-colors"
          >
            <svg className="w-5 h-5 text-anutel flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
            </svg>
            <span className="text-sm font-medium text-gray-700">{doc.label}</span>
          </Link>
        ))}
      </div>
    </div>
  );
}
